// Страховка
export function stepInsurance (proxy)
{
    let controller = {
        checked: false,
        input: false,
    }

    const data = proxy.data
    const step = 'step'+data.step;

    // Событие customSelect что запускаем 1 раз
    if (!data.btnNext) data.customSelectActive(proxy);

    const fiWrapper = proxy.fvcContainerId.querySelector('.fi_wrapper')
    const contWrapper = fiWrapper.querySelector('.cont_warning')
    const formContBox = fiWrapper.querySelector('.form_cont_box')

    const checkboxWrapper = proxy.fvcContainerId.querySelector('.checkbox_wrapper_js');
    const selectInputs = checkboxWrapper.querySelectorAll('.option_wrapper input');
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    const totalPrice = totalInformationWrapper.querySelector('.total_js')
    const checkbox = checkboxWrapper.querySelector('input[type=checkbox]');

    const dataLS1 = data.getStepLocalStorage(proxy.locStorStepId, 1);
    const dataLS2 = data.getStepLocalStorage(proxy.locStorStepId, 2);
    let dataLS = data.getStepLocalStorage(proxy.locStorStepId, data.step);

    if (!dataLS) dataLS = data.dataForm[step]

    const priceVisaS1 = data.getNumberParser(dataLS1.prise)
    const nameVisaS1 = dataLS1.name

    // Удаляем данные с LOCAL_STORAGE с ключём "dws_form_step_step7"
    // localStorage.removeItem(proxy.visual.LOCAL_STORAGE_STEP_ID+data.step)

    // debugger;

    // visaTypePrice.innerText = priceVisa
    // const tirPriceNumber = proxy.data.getNumberParser(tirPrice.innerText)
    // console.log('tirPriceNumber => ', tirPriceNumber)

    // console.log(priceVisa)
    // console.log(totalPrice.innerText)
    // console.log(visaTypePrice.innerText)

    const key = checkboxWrapper.dataset.name;
    // const dataFormLoad = {[key]: data.dataForm[step][key]}

    // Удаляем блок с комментарием и класс active
    if (contWrapper) contWrapper.remove();
    if (checkboxWrapper.classList.contains('active')) {
        checkboxWrapper.classList.remove('active');
    }

    // Если выбран "Референс код" с ID = 5
    if (dataLS1.id === '5') {

        dataLS.validityInsurance.check = false;
        dataLS.validityInsurance.price = false;
        dataLS.validityInsurance.prise = false;
        // proxy.data.dataForm[step].validityInsurance.days = false;
        // proxy.data.dataForm[step].validityInsurance.prise = false;
        formContBox.style.display = 'none';

        fiWrapper.insertAdjacentHTML("afterbegin", data.mgsHtmlInsurance('REF_FALSE'))
    }
    else
    {
        checkbox.checked = true;

        dataLS.validityInsurance.check = true;
        fiWrapper.insertAdjacentHTML("afterbegin", data.mgsHtmlInsurance('REF_CODE'))

        formContBox.style.display = 'block';
        if (!checkboxWrapper.classList.contains('active')) {
            checkboxWrapper.classList.add('active');
        }

        if (dataLS) {
            data.setDataFormAddLocalStorage(data.dataForm[step], dataLS);
        } else {
            dataLS = data.dataForm[step];
        }

        /*else {
            // const newData = getDefaultDataFormLoader(proxy, dataFormLoad)
            // console.log('newData => ', newData)
            // debugger;
            // data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataFormLoad, data.step);
            // dataLocalStorage = dataFormLoad
        }*/

        // Вставляем строку в таблицу
        // setTotalInformation (proxy, dataLS.validityInsurance.prise, key, 'Страховка')
    }


    // data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, 2);
    data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);

    // fiWrapper.insertAdjacentHTML("afterbegin", data.mgsHtmlInsurance('REF_CODE'))

    // Событие при активации чекбокса (Вывод стоимости в таблицу)
    checkbox.addEventListener('customCheckClick', e => {
        const data = e.detail.proxy.data;
        const dataForm = e.detail.dataForm;
        const key = e.detail.name;
        const step1 = data.getStepLocalStorage(e.detail.proxy.locStorStepId, 1)
        const total = document.querySelector('.total_js')
        const priseS1 = data.getNumberParser(step1.prise)

        if (dataForm.check) {
            // tirPriceIn.innerText = dataForm.price;

            // Вставляем строку в таблицу
            setTotalInformation (e.detail.proxy, dataForm.prise, key, 'Страховка')

            const prise = data.getNumberParser(dataForm.prise)
            total.innerText = data.numberWithSpaces(priseS1 + prise) + BX.message('R');
        } else {
            // Удаляем строку с таблицу
            dellTotalInformation (e.detail.proxy, key)

            // tirPriceIn.innerText =  0 + BX.message('R')
            total.innerText = step1.prise;
        }
    });


    // Событие при переключении select
    selectInputs.forEach(select => {
        select.addEventListener('customSelectClick', e => {

            // Новый функционал: стоимость получаем из настроек dwstroy.core
            let resPrice = '';
            e.detail.proxy.params.RESULT.ITEMS.STEP_7.forEach(item => {
                if (item['ID'] === e.target.value) {
                    resPrice = Number(item['PRICE'])
                }
            })

            const proxy = e.detail.proxy;
            const dataForm = e.detail.dataForm;
            const checkboxWrapper = e.detail.checkboxWrapper;
            const value = e.detail.value;
            const total = document.querySelector('.total_js')
            const step1 = data.getStepLocalStorage(e.detail.proxy.locStorStepId, 1)
            const priseS1 = data.getNumberParser(step1.prise)

            const step = 'step'+proxy.data.step;
            const nameData = checkboxWrapper.dataset.name;
            const inputBoxPrice = checkboxWrapper.querySelector('.input_box_price')
            const priseName = inputBoxPrice.dataset.name


            // Новый функционал: стоимость получаем из настроек dwstroy.core
            let priseNumber = '';
            if (proxy.params.CONFIG.SETTINGS_DWSTROY_CORE === 'Y') {
                priseNumber = resPrice
            } else {
                priseNumber = proxy.data.insuranceCost(proxy, dataLS2.age, value)
            }

            const prise = proxy.data.numberWithSpaces(priseNumber) + BX.message('R')

            updateTotalInformationPrise(proxy, nameData, prise);

            // tirPriceIn.innerText = dataForm.price
            inputBoxPrice.innerText = prise
            proxy.data.dataForm[step][nameData][priseName] = prise;

            setEventPriceHtml(proxy.data, priseNumber, proxy.data.dataForm[step][nameData], total, priseS1);
        });
    })

    // console.log('dataName => ', {[key]: '3253453'})

    if (dataLS2) {
        setLoadValidity(proxy, step, key);
        setLoadPrice(proxy, step, dataLS2.age, key, dataLS1.id);

        // количество лет
        if (dataLS2.age) {
            setAgeText(proxy, dataLS2.age);
        } else {
            // Перенаправляем на 2 step
            reloadDataLS2(proxy, dataLS2);
        }

        if (dataLS2.surname && dataLS2.name && dataLS2.fatherName) {
            setFioText(proxy.fvcContainerId, dataLS2.surname, dataLS2.name, dataLS2.fatherName);
        }
    } else {
        // Перенаправляем на 2 step
        reloadDataLS2(proxy, dataLS2);
    }

    // const priseInsuranceCost = proxy.data.insuranceCost(proxy, dataLS2.age, dataLS.validityInsurance.days)

    // Делаем расчёт и выводим сумму при загрузке страницы
    setPriseTableLoaderHtml(proxy, priceVisaS1, nameVisaS1, totalPrice, step);

    // BX.bind(checkbox, 'click', BX.proxy(checkboxClickControlLS, proxy));
    // BX.bind(proxy.bNext, 'click', BX.proxy(bNextClickControlLS, proxy));

    // console.log(proxy.bNext)
    // console.log(proxy.bPrev)

    /*function bNextClickControlLS (e) {
        if (e.target) {
            console.log('e => ', this.data.dataForm['step'+this.data.step])
            this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, this.data.dataForm['step'+this.data.step], this.data.step);
        }
    }*/

    // Перезаписываем LocalStorage при вводе данных в input
    // data.setInputClickLocalStorage(proxy, data.dataForm[step]);

    // Заполняем в input данными с dataForm и обновляем dataForm
    data.setTextInputDataForm(proxy.fvcContainerId, data.dataForm[step]);

    proxy.data.btnNext = true;
    proxy.bNext.classList.add('in');
}

function reloadDataLS2 (proxy, dataLS2) {
    dataLS2.age = false
    dataLS2.date = false
    dataLS2.dateRFC2822 = false
    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS2, 2);

    // Перенаправляем на 2 step
    proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, 2)
    location.reload();
}

// Проставляем количество дней действия страховки в select при загрузке
function setLoadValidity (proxy, step, key) {
    const span = proxy.fvcContainerId.querySelector('.select_wrapper span');
    const input = proxy.fvcContainerId.querySelector('.option_wrapper input[checked]');

    // Новый функционал: стоимость получаем из настроек dwstroy.core
    let arrInsurance = '';
    let text = '';
    if (proxy.params.CONFIG.SETTINGS_DWSTROY_CORE === 'Y') {
        arrInsurance = proxy.params.RESULT.ITEMS.STEP_7;
    }

    if (proxy.data.dataForm[step][key].days)
    {
        // Новый функционал: стоимость получаем из настроек dwstroy.core
        if (arrInsurance) {
            arrInsurance.forEach(item => {
                if (item['ID'] === proxy.data.dataForm[step][key].days) {
                    text = item['TEXT']
                }
            })
        }

        // Новый функционал: стоимость получаем из настроек dwstroy.core
        if (text) {
            span.innerText = text;
        } else {
            span.innerText = proxy.message['DAYS_'+proxy.data.dataForm[step][key].days];
        }

    } else {
        span.innerText = proxy.message['DAYS_1'];
    }
}

// Подставляем цены при загрузке и записываем дата в ЛС
function setLoadPrice (proxy, step, age, key, dataLS1Id) {
    const inputBox = proxy.fvcContainerId.querySelector('.input_box_price');
    const input = proxy.fvcContainerId.querySelector('.option_wrapper input[checked]');
    const priseName = inputBox.dataset.name;
    let dataLS = false;
    let priseAge = 0;

    // Получаем объект с LocalStorage
    dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    if (!dataLS) {
        dataLS = proxy.data.dataForm[step]
    }

    // получаем стоимость если не референс код
    if (dataLS1Id !== '5') priseAge = proxy.data.insuranceCost(proxy, age, dataLS[key]['days']);


    const prise = proxy.data.numberWithSpaces(priseAge) + BX.message('R')

    dataLS[key][priseName] = prise
    inputBox.innerText = prise;

    const priseInsuranceCost = proxy.data.insuranceCost(proxy, age, dataLS[key]['days'])

    if (dataLS[key] && priseInsuranceCost) {
        // inputBox.innerText = proxy.data.dataForm[step][key][priseName];
        inputBox.innerText = proxy.data.numberWithSpaces(proxy.data.insuranceCost(proxy, age, dataLS[key]['days']) + BX.message('R'))
    }

    if (!dataLS[key].check) {
        dellTotalInformation (proxy, key) // Удаляем строку с таблицу
    } else {
        const prise = dataLS[key][priseName]
        setTotalInformation (proxy, prise, key, 'Страховка') // Вставляем строку в таблицу
        dataLS[key][priseName] = prise
    }

    /*if (!proxy.data.dataForm[step][key].check) {
        tirPriceIn.innerText = 0 + BX.message('R')
    } else {
        tirPriceIn.innerText = proxy.data.dataForm[step][key][priceName]
        proxy.data.dataForm[step][key][priceName] = proxy.data.dataForm[step][key][priceName]
    }*/

    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, proxy.data.step);
}

// Обновляем цену в таблице
function setEventPriceHtml (data, priseNumber, step, total, priseS1) {
    if (step.check) {
        total.innerText = data.numberWithSpaces(priseNumber + priseS1) + BX.message('R')
    }
    /*if (!step.check) {
        tirPriceIn.innerText = 0 + BX.message('R')
    } else {
        tirPriceIn.innerText = step[priceName]
        total.innerText = data.numberWithSpaces(priseNumber + priseS1) + BX.message('R')
    }*/
}

// Выводим возраст на странице
function setAgeText (proxy, age) {
    let spanAge = proxy.fvcContainerId.querySelector('.us_age span')
    let newSpan = spanAge.innerText.replace('%--%', age);
    newSpan = newSpan.replace('#--#', proxy.data.getNumWord(age, ['год', 'года', 'лет']));
    spanAge.innerText = '';
    spanAge.insertAdjacentHTML("afterbegin", newSpan)
}

// Выводим ФИО
function setFioText (fvcContainerId, surname, name, fatherName) {
    const fullNameSpan = fvcContainerId.querySelector('.us_full_name span')
    const fullName = surname +' '+ name +' '+ fatherName;
    fullNameSpan.innerText = '';
    fullNameSpan.insertAdjacentHTML("afterbegin", fullName)
}

// Вставляем строку в таблицу
function setTotalInformation (proxy, prise, key, name) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    const totalInformation = proxy.data.tableRowHtml (name, prise, key);

    totalInformationWrapper.insertAdjacentHTML("afterbegin", totalInformation)
}

// Удаляем строку с таблицу
function dellTotalInformation (proxy, key) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    const totalInformation = totalInformationWrapper.querySelector(`[data-key=${key}]`)
    if (totalInformation) totalInformation.remove();
}

// Обновляем сумму в таблице
function updateTotalInformationPrise (proxy, key, prise) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    const totalInformation = totalInformationWrapper.querySelector(`[data-key=${key}]`)


    if (totalInformation) {
        const tirPrise = totalInformation.querySelector('.tir_prise')
        tirPrise.innerText = prise
    }
}

// Делаем расчёт и выводим сумму при загрузке страницы
function setPriseTableLoaderHtml (proxy, priceVisaS1, nameVisaS1, totalPrice, step)
{
    const data = proxy.data;
    const dataLS = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    let tirPriceIn = dataLS.validityInsurance.prise

    // visaName.innerText = nameVisaS1 + ':';
    // visaPrice.innerText = data.numberWithSpaces(priceVisaS1) + BX.message('R');

    // tirPriceIn.innerText = data.numberWithSpaces(data.getNumberParser(tirPriceIn.innerText)) + BX.message('R');

    let priseResult = false;
    const priseVisaS1 = data.numberWithSpaces(priceVisaS1) + BX.message('R'); // стоимость визы (1 320 ₽)

    setTotalInformation (proxy, priseVisaS1, 'typeOfVisa', nameVisaS1)

    if (tirPriceIn && data.dataForm[step].validityInsurance.check) {
        priseResult = priceVisaS1 + data.getNumberParser(tirPriceIn)
    } else {
        priseResult = priceVisaS1
    }

    totalPrice.innerText = data.numberWithSpaces(priseResult) + BX.message('R');
}



// Возвращает DataForm по дефолту при загрузке страницы
/*function getDefaultDataFormLoader (proxy, dataForm) {
    const select = proxy.fvcContainerId.querySelector('.select_wrapper span').innerText
    const input = proxy.fvcContainerId.querySelector('.input_box_price').innerText
    let dataName = [];
    let newDataForm = {}
    let newDF = {}

    // Устанавливаем флаг чекбокса
    Object.entries(dataForm).forEach((entry) => {
        const [key] = entry;
        dataName.push(key)
    });

    dataName.forEach(item => {
        Object.entries(dataForm[item]).forEach((entry) => {
            const [key, value] = entry;
            switch (key) {
                case "check":
                    newDF[key] = value
                    break;
                case "days":
                    newDF[key] = select
                    break;
                case "price":
                    newDF[key] = input
                    break;
            }
        });
        newDataForm = {[item]: newDF}
    })

    return newDataForm;
}*/